
		/*![Stylized phone schematic](/blog-images/mamabear-postcover.gif)*/
/*<cap>
<subt><span class="material-symbols">info</span>Image Credit: Research In Motion, edited by me</subt>
</cap>*/
/*not sure if this should go here*/
/*On a modern smartphone, you'll often times find yourself "fake-multitasking". Similar to, say, running multiple programs on a single-thread CPU, the human mind can only focus on a single task on the time. What your concious mind perceives as multitasking is actually your brain rapid-fire switching between all of the tasks*/
/*!!(insert a generic picture of a blackberry here)!!*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "On brainrot, intentionality, and the physical cellphone keyboard";
export const description = "Or, how physically segmenting your digital life can help un-fry your brain";
export const image = "/blog-images/brainrot-cover.jpg";
export const tags = ["Opinion"];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    em: "em",
    h2: "h2",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: ["\n", "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/brainrot-cover.jpg",
        alt: "A set of devices laid out on a table. In the center is a BlackBerry Curve, with a PSP, a JVC camcorder, a 5th gen iPod, and a Casio watch around it"
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      }), _jsx("br", {}), _jsxs("subt", {
        children: ["Canon EOS 550D + 22mm f/4.5 | 1/60s | ISO 800 | ", _jsx(_components.a, {
          href: "/blog-images/brainrot-cover-fullsize.jpg",
          children: "View full-size image."
        })]
      })]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["This post originally started as something where I ", _jsx(_components.a, {
          href: "https://wetdry.world/@fish/115722187976177074",
          children: "talked about my experience"
        }), " using BlackBerry's software keyboard on Android, but soon morphed into a discussion about reclaiming your attention span in a world where everything seems to be hand over fist in trying to take a slice of it."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "I have a pretty weird hobby: collecting old BlackBerry phones. All my friends call me crazy, but on the other hand I've talked to many former RIM employees who've assured me otherwise. Nonetheless, there's been one thing that's stuck with me: those keyboards were goddamn excellent."
    }), "\n", _jsx(_components.h2, {
      children: "My experiences"
    }), "\n", _jsx(_components.p, {
      children: "In the past few months, I've personally been trying to fix my attention span somewhat by segmenting my digital life. I usually carry a mobile phone for communication, a camcorder for taking photos and video, an iPod for listening to music, and a PSP for playing video games. This makes it so moving between digital tasks requires you to take your attention off the current device, physically swap devices, and then finally refocus on the new task. This is unlike the current paradigm, where everything you do is an app on your phone, and you end up doing multiple things at once and keeping multiple tasks on your mind at once (which does get rather fatiguing!)"
    }), "\n", "\n", "\n", _jsxs(_components.p, {
      children: ["I did attempt to daily drive a BlackBerry Q10 from my collection for about a week, but dealing with the sheer pile of workarounds needed to make modern messengers usable quickly got tedious. I have since decided to concede that part of my life and switch back to a mainstream vertical phone, but I do have a pre-order placed for the ", _jsx(_components.a, {
        href: "https://linkapus.com/products/q25-pro-full-device",
        children: "Zinwa Technologies Q25"
      }), " (a BlackBerry Classic retrofitted with a modern budget Android mainboard) and it should be arriving in late January of 2026. Earlier backers have already received their units, and they seem to be going pretty well quality-wise, so expect a full review on this blog when my unit arrives."]
    }), "\n", _jsx(_components.p, {
      children: "Now, let's get to where it all ties in with the physical form factor of the keyboard phone."
    }), "\n", _jsx(_components.h2, {
      children: "Form factor is everything"
    }), "\n", "\n", _jsxs("p", {
      class: "image-item",
      children: [_jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "/blog-images/q10.jpg",
          alt: "A BlackBerry Q10"
        })
      }), _jsxs("cap", {
        children: [_jsxs("subt", {
          children: [_jsx("span", {
            class: "material-symbols",
            children: "info"
          }), "Image credit: Me."]
        }), _jsx("br", {}), _jsxs("subt", {
          children: ["Canon EOS 550D + 17mm f/4.5 | 1/60s | ISO 800 | ", _jsx(_components.a, {
            href: "/blog-images/q10-fullsize.jpg",
            children: "View full-size image."
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "This is a BlackBerry Q10, released in 2013. It has a 3.1 inch 720p AMOLED, 2GB of RAM, 16GB of storage, and a 35-key QWERTY keyboard."
    }), "\n", _jsx(_components.p, {
      children: "The first thing that you'll notice is that the aspect ratio is extremely inconvenient for things like short-form vertical video, but very useful for doing things like writing emails. The Q10 specifically has a square screen, but the majority of devices of this form factor used horizontal screens typically at a 4:3 aspect ratio."
    }), "\n", _jsx(_components.p, {
      children: "Usually on a mainstream, vertically-oriented phone, you get the same usable amount of screen space when composing text as on a keyboard phone. The key part is when you're composing text. Due to, well, consumer wants, modern phones are content consumption machines first and foremost. You scroll X, TikTok, and Instagram vertically, and you occasionally rotate the phone sideways to watch traditional horizontal video. The originally-intended purpose of the device, to make phone calls and send messages to people, is demoted to a secondary function."
    }), "\n", _jsxs(_components.p, {
      children: ["Apart from the attention span bit, physical keyboards on phones have other benefits. One example I've heard is that it's much easier to type while busy doing something like driving ", _jsx("subt", {
        children: "(for legal reasons I don't condone this bla bla bla)."
      }), " Additionally, a hallmark feature of some phones of that era (especially BlackBerry devices) is the ability to navigate the operating system through a set of hardware navigation buttons in addition to a trackball, optical trackpad, or rotary encoder. This enables the use of the device with gloves, an absolute godsend in my home country of Canada, where in the winter your hands ", _jsx(_components.em, {
        children: "will"
      }), " get cold and numb after a minute of typing on a touchscreen phone."]
    }), "\n", _jsx(_components.h2, {
      children: "Conclusion"
    }), "\n", _jsx(_components.p, {
      children: "Maybe it is time to make a returnal to how we used to do it. Maybe we will be better off doing it. But there's only one way to find out."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	